import React from "react";
import PrimaryButton from "../PrimaryButton";
import { Table } from "react-bootstrap";

const PastUploadsTable = ({
  ongoingUploadStatus,
  headers = [],
  pastUploads = [],
  handleRetry,
  handleDownload,
}) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    date.setHours(date.getHours() + 8);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;

    return formattedDate;
  };

  const getSublocationName = (sublocation_names) => {
    if(!sublocation_names) return "";
    return sublocation_names.join(", ");
  }

  return (
    <Table responsive bordered width="100%" cellSpacing={0}>
      <thead>
        <tr>
          {headers?.map((header, index) => (
            <th key={index}>{header?.title}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {pastUploads?.map((upload, index) => (
          <tr key={index}>
            <td>
              <p>{formatDate(upload?.created_at)}</p>
            </td>
            <td>
              <p>{upload?.uploaded_by_user}</p>
            </td>
            <td>
              <p>{getSublocationName(upload?.sublocation_name)}</p>
            </td>
            <td>
              <PrimaryButton
                className="bg-white text-dark"
                text="Download"
                onClick={() => handleDownload(upload?.upload_file_id)}
              />
            </td>
            <td>
              <p>{upload?.status}</p>
            </td>
            <td>
              <PrimaryButton
                className="bg-white text-dark"
                text="Download"
                disabled={!upload?.report_file_id}
                onClick={() => handleDownload(upload?.report_file_id)}
              />
            </td>
            <td>
              {ongoingUploadStatus != "PROCESSING" &&
                upload?.status != "PROCESSING" &&
                upload?.status != "SUCCESS" && (
                  <PrimaryButton
                    text="Retry"
                    onClick={() => handleRetry(upload?.id)}
                  />
                )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default React.memo(PastUploadsTable);
